import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    elementId: String
  }
  static targets = ["content"]
  static classes = ["collapsed"]

  toggle(event) {
    event.preventDefault()
    if(this.isClosed) {
      this.show()
    } else {
      this.hide()
    }
  }

  get isClosed() {
    return this.contentTarget.classList.contains(this.collapsedClass);
  }

  show() {
    this.element.classList.remove('collapsed')
    this.contentTarget.classList.remove(this.collapsedClass)
  }

  hide() {
    this.element.classList.add('collapsed')
    this.contentTarget.classList.add(this.collapsedClass)
  }
}
